module.exports = __webpack_public_path__ + "img/D2-b.8dcddd31.jpg";